export default __webpack_public_path__ + "static/media/contact.1723dea2.jpg";